import { Button, Form, Input } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import { v4 as uuid } from "uuid";

import { api, endpoint } from "@/api";
import { userRole } from "@/constant";
import TextArea from "antd/es/input/TextArea";
import { flare } from "@flareapp/js";

const onFinishFailed = (errorInfo) => {
  // eslint-disable-next-line no-console
  console.log("Failed:", errorInfo);
};

function MetaCustomReportTemplateModal({ show, setShow, setData, mode = "create", data = {}, getData }) {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user);

  // const { name, description } = data;

  const [selectedBusiness, setSelectedBusiness] = useState();

  // fetch
  const getBusiness = async () => {
    try {
      const data = await api.get(endpoint.business);

      if ((Array.isArray(data?.data) && data.data.length === 1) || userDetails.role !== userRole.superAdmin) {
        setSelectedBusiness(data.data[0]._id);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("business list", error);
    }
  };

  useEffect(() => {
    getBusiness();
    form.setFieldsValue({ ...data });
  }, [mode]);

  const handleClose = () => {
    if (mode === "create") {
      navigate("/report-template-list");
    }
    setShow(false);
    form.setFieldsValue({});
  };

  // Report Tempalte operation
  // const deleteHandler = () => {
  //   try {
  //     Swal.fire({
  //       title: "Are you sure?",
  //       text: "Do you wish to delete this report template?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Confirm",
  //     }).then(async (result) => {
  //       if (result.isConfirmed) {
  //         const response = await axios.delete(`${endpoint.remove_customReport_template}/${data._id}`, {
  //           withCredentials: true,
  //         });
  //         if (response.status === 200) {
  //           Swal.fire("Deleted!", "Report Template has been deleted.", "success");
  //           navigate("/report-template-list");
  //         }
  //       }
  //     });
  //   } catch (error) {
  // flare.report(error);
  //     // eslint-disable-next-line no-console
  //     console.log(error);
  //   }
  // };

  const handleUpdate = async (body) => {
    try {
      const response = await axios.put(endpoint.update_customReport_template + "/" + data._id, body, {
        withCredentials: true,
      });
      if (response.status === 204) {
        // Swal.fire("", "Report Template Updated Successfully!", "success");
        getData();
        handleClose();
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const handleCreate = async (body) => {
    try {
      const { data } = await axios.post(endpoint.create_customReport_template, body, { withCredentials: true });

      if (data?.success) {
        await Swal.fire("", `Report Template Created Successfully!`, "success");
        navigate(`/edit-report-template/${data?.result?._id}`);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const onFinish = async (values) => {
    const reportType = uuid();
    const body = {
      ...values,
      reportType,
    };
    if (mode === "copy") {
      setData((pre) => ({ ...pre, ...values }));
      setShow(false);
    } else if (mode === "create") {
      body.user = userDetails._id;
      body.business = selectedBusiness;
      handleCreate(body);
    } else {
      handleUpdate(body);
    }
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} centered size="lg" backdropClassName="modal-bg-1">
        {/* header */}
        <Modal.Header closeButton className="bg-gray-200 border-dark-subtle">
          <Modal.Title>{mode === "create" ? "Add Report Template" : "Edit Report Template"}</Modal.Title>
        </Modal.Header>
        {/* body */}
        <Modal.Body className="p-3">
          <Form
            name="createDashboard"
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
          >
            <Row lg={2}>
              <Col>
                <Form.Item label="Name" name="name" rules={[{ required: true, message: "Input Report Template Name" }]}>
                  <Input placeholder="Enter Report Template Name" />
                </Form.Item>
              </Col>
            </Row>
            <Row lg={2}>
              <Col>
                <Form.Item
                  label="Description"
                  name="description"
                  showCount
                  maxLength={100}
                  rules={[{ required: true, message: "Input Report Template Description" }, { max: 100 }]}
                >
                  <TextArea rows={3} placeholder="Enter Report Template Description" />
                </Form.Item>
              </Col>
            </Row>

            <div className="d-flex align-items-center justify-content-end gap-3">
              <Button type="primary" htmlType="submit">
                {mode === "create" ? "Create Report Template" : "Update Report Template"}
              </Button>
              <Button type="default" onClick={handleClose} danger htmlType="button">
                Cancel
              </Button>
              {/* {mode === "edit" && data._id && (
                <Button type="default" onClick={deleteHandler} danger htmlType="button">
                  Delete Report Template
                </Button>
              )} */}
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default MetaCustomReportTemplateModal;

MetaCustomReportTemplateModal.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  setData: PropTypes.func,
  mode: PropTypes.string,
  data: PropTypes.object,
  getData: PropTypes.func,
};
